// Reset-to-template helper (Requirement 7.7).
//
// Reset restores the Problem_Template DEFAULTS derived from its Source_Tree,
// NOT the loaded/saved snapshot. This guarantees that confirming reset always
// returns the working tree to the template's original contents regardless of
// which files were added, modified, or deleted beforehand.

import type { MachineCodingTemplate } from '../../data/machine-coding-templates/types';
import { extractFileContents } from './fileTree';

/** Return the template's default File_Contents, derived from its Source_Tree. */
export function resetToTemplate(template: MachineCodingTemplate): { [path: string]: string } {
 return extractFileContents(template.fileStructure);
}
